// extracted by mini-css-extract-plugin
export default {"AppCarousel":"AppCarousel_AppCarousel__Y-BmP","CarouselCaption":"AppCarousel_CarouselCaption__Qzvdt"};